import {css} from 'styled-components';

import {ReactElement, useEffect, useRef} from 'react';

import {makeElementsUnfocusable, Nullish} from 'shared/web';

interface OffscreenContentProps {
  children: ReactElement | Nullish;
}

export function OffscreenContent(props: OffscreenContentProps) {
  const containerRef = useRef<HTMLDivElement>(null);

  useEffect(() => {
    const container = containerRef.current;
    // makeElementsUnfocusable handles null containers and returns a no-op cleanup
    const cleanup = makeElementsUnfocusable(container);
    return cleanup;
  }, [props.children]);

  return (
    <div
      ref={containerRef}
      tabIndex={-1}
      aria-hidden="true"
      // margin is required for offscreen positioning technique
      // eslint-disable-next-line eag/no-css-property
      css={css`
        position: fixed;
        width: 1px;
        height: 1px;
        top: -9000px;
        left: -9000px;
        opacity: 0;
        pointer-events: none;
        clip: rect(0 0 0 0);
        margin: -1px;
        overflow: hidden;
      `}
    >
      {props.children}
    </div>
  );
}
